export const ClimbedPodiumIcon = () => {
  return (
    <svg
      width="37"
      height="33"
      viewBox="0 0 37 33"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="2"
        y="1"
        width="32"
        height="32"
        rx="16"
        fill="url(#paint0_linear_19413_6138)"
        fillOpacity="0.16"
      />
      <path
        d="M18.8379 21.1176V22.8357H23.0046V24.5024H13.0046V22.8357H17.1712V21.1176C13.8826 20.7075 11.3379 17.9022 11.3379 14.5024V9.50244H24.6712V14.5024C24.6712 17.9022 22.1265 20.7075 18.8379 21.1176ZM8.83789 11.1691H10.5046V14.5024H8.83789V11.1691ZM25.5046 11.1691H27.1712V14.5024H25.5046V11.1691Z"
        fill="#EBBD46"
      />
      <path
        d="M36.9998 6.01224C33.7812 6.20634 31.2057 8.78199 31.0116 12.0005H30.9881C30.794 8.78199 28.2185 6.20634 25 6.01224V5.98874C28.2185 5.79464 30.794 3.21908 30.9881 0.000488281H31.0116C31.2057 3.21908 33.7812 5.79464 36.9998 5.98874V6.01224Z"
        fill="#F2D383"
      />
      <path
        d="M6.99988 24.5073C5.1224 24.6206 3.61999 26.123 3.50677 28.0005H3.49306C3.37983 26.123 1.87743 24.6206 0 24.5073V24.4936C1.87743 24.3804 3.37983 22.878 3.49306 21.0005H3.50677C3.61999 22.878 5.1224 24.3804 6.99988 24.4936V24.5073Z"
        fill="#F2D383"
      />
      <defs>
        <linearGradient
          id="paint0_linear_19413_6138"
          x1="18"
          y1="1"
          x2="18"
          y2="33"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="#999999" />
        </linearGradient>
      </defs>
    </svg>
  );
};
